<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <TableLabel
          :label="'NC'"
          labelKey="table_label_ncNo"
          :value="row.ncNo"
        />
        <TableLabel
          :label="'SKU'"
          labelKey="table_label_hxSkuNo"
          :value="row.hxSkuNo"
        />
        <TableLabel
          :label="'UPC'"
          labelKey="table_label_eanCode"
          :value="row.eanCode"
        />
      </template>
      <template v-slot:displayChannel="{ row }">
        <TableLabel
          :label="'Item'"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
        />
        <TableLabel
          :label="'SKU'"
          labelKey="table_label_channelSkuNo"
          :value="row.channelSkuNo"
        />
        <TableLabel
          :label="'UPC'"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
        />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
}
</script>
